/* ═══════════════════════════════════════════════════════════
   TRIOMI PRODUKTSEITEN — gemeinsame Logik (Präfix: tpx)
   Galerie · Varianten · Menge · Sticky-Leiste · Judge.me-Namen

   Preorder-Apps (z. B. Rapid Preorder): Dieses Script schreibt NIE
   den Text des Haupt-Buttons (#tpxAtc) um und sendet den Warenkorb
   nie selbst per fetch. Die Sticky-Leiste klickt den Haupt-Button,
   damit die App ihre Logik (Vorbestellung, Anzahlung …) ausführt.
═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var form = document.getElementById('tpxForm');
  var dataEl = document.getElementById('tpxData');
  if (!form || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variants = data.variants || [];
  var idInput = document.getElementById('tpxVariantId');
  var qtyInput = document.getElementById('tpxQty');
  var atc = document.getElementById('tpxAtc');
  var buyBox = document.getElementById('tpxBuy');
  var priceEl = document.getElementById('tpxPrice');
  var compareEl = document.getElementById('tpxCompare');
  var saveEl = document.getElementById('tpxSave');
  var totalEl = document.getElementById('tpxTotal');
  var mainImg = document.getElementById('tpxMainImgEl');
  var options = data.selected.slice();

  /* ── Geldformat: übernimmt das Muster des serverseitig gerenderten Preises ── */
  var nf = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents, sample) {
    var pattern = /[\d.,]+/.test(sample || '') ? sample.replace(/[\d.,]+/, '{n}') : '{n}\u00a0\u20ac';
    return pattern.replace('{n}', nf.format(cents / 100));
  }

  function currentVariant() {
    var id = idInput ? parseInt(idInput.value, 10) : 0;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0];
  }
  function qty() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : Math.min(q, 99);
  }

  /* ── Anzeige aktualisieren ── */
  var stickyPriceEl = document.getElementById('tpxStickyPrice');
  var stickyQtyEl = document.getElementById('tpxStickyQty');

  function renderTotals() {
    var v = currentVariant();
    if (!v) return;
    var q = qty();
    if (totalEl) {
      totalEl.innerHTML = q > 1 ? 'Gesamt: <strong>' + money(v.price * q, v.price_fmt) + '</strong>' : '';
    }
    if (stickyPriceEl) stickyPriceEl.textContent = money(v.price * q, v.price_fmt);
    if (stickyQtyEl) stickyQtyEl.textContent = q;
  }

  function applyVariant(v) {
    if (!v) return;
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price_fmt;
    var hasSale = v.compare_at_price && v.compare_at_price > v.price;
    if (compareEl) {
      compareEl.textContent = hasSale ? v.compare_fmt : '';
      compareEl.hidden = !hasSale;
    }
    if (saveEl) {
      saveEl.hidden = !hasSale;
      if (hasSale) saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
    }
    if (v.image && mainImg) {
      mainImg.src = v.image;
      document.querySelectorAll('.tpx-thumb').forEach(function (t) {
        t.classList.toggle('active', t.dataset.src === v.image);
      });
    }
    /* Preorder-Vorlage: Button gehört der App, hier nichts anfassen.
       Sonst: bei Ausverkauft deaktivieren, bei Verfügbar wieder freigeben. */
    if (atc && !data.preorder) {
      if (!v.available) { atc.disabled = true; atc.textContent = 'Ausverkauft'; }
      else if (atc.disabled) { atc.disabled = false; atc.textContent = 'In den Warenkorb'; }
    }
    var sAtc = document.getElementById('tpxStickyAtc');
    if (sAtc && atc) sAtc.disabled = atc.disabled;

    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    /* Apps (Preorder, Bewertungen …) horchen oft auf Änderungen am id-Feld */
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    renderTotals();
  }

  /* ── Varianten-Buttons ── */
  document.querySelectorAll('.tpx-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(this.dataset.optIdx, 10);
      this.closest('.tpx-opt-btns').querySelectorAll('.tpx-opt-btn').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-pressed', 'true');
      var lbl = document.getElementById('tpxOptVal' + idx);
      if (lbl) lbl.textContent = this.dataset.optVal;
      options[idx] = this.dataset.optVal;
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      })[0];
      if (match) applyVariant(match);
    });
  });

  /* ── Mengen-Stepper ── */
  function setQty(n) {
    n = Math.max(1, Math.min(99, n));
    if (qtyInput) qtyInput.value = n;
    renderTotals();
  }
  document.querySelectorAll('.tpx-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setQty(qty() + parseInt(this.dataset.delta, 10));
    });
  });
  if (qtyInput) qtyInput.addEventListener('input', renderTotals);

  /* ── Galerie ── */
  document.querySelectorAll('.tpx-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) { mainImg.src = this.dataset.src; mainImg.alt = this.dataset.alt || mainImg.alt; }
      document.querySelectorAll('.tpx-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Sticky-Leiste ── */
  var bar = document.getElementById('tpxSticky');
  var sAtc = document.getElementById('tpxStickyAtc');
  if (bar && buyBox && sAtc) {
    /* Bar erscheint, sobald der Kaufbereich aus dem Viewport ist.
       Beobachtet den Container (nicht den Button), falls eine App den Button austauscht. */
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buyBox);

    document.getElementById('tpxStickyMinus').addEventListener('click', function () { setQty(qty() - 1); });
    document.getElementById('tpxStickyPlus').addEventListener('click', function () { setQty(qty() + 1); });

    /* Beschriftung vom Haupt-Button spiegeln (z. B. "Vorbestellen" von der App) */
    function mirrorLabel() {
      var main = document.getElementById('tpxAtc');
      if (!main) return;
      var txt = (main.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) sAtc.textContent = txt;
      sAtc.disabled = main.disabled;
    }
    mirrorLabel();
    new MutationObserver(mirrorLabel).observe(buyBox, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    sAtc.addEventListener('click', function () {
      var main = document.getElementById('tpxAtc');
      if (main && !main.disabled) main.click();
    });
  }

  /* ── Judge.me: Nachnamen kürzen (DSGVO) ── */
  var root = document.getElementById('judgeme_product_reviews');
  if (root) {
    var sels = ['.jdgm-rev__author', '.jdgm-rev__author-name', '.jdgm-carousel-item__reviewer-name', '.jdgm-carousel-item__author'];
    var shorten = function () {
      sels.forEach(function (sel) {
        root.querySelectorAll(sel).forEach(function (el) {
          if (el.dataset.trShortened === '1') return;
          var raw = (el.textContent || '').trim();
          if (!raw) return;
          var p = raw.split(/\s+/);
          if (p.length >= 2 && p[p.length - 1].length > 1 && !/^[A-ZÄÖÜ]\.$/.test(p[p.length - 1])) {
            el.textContent = p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.';
          }
          el.dataset.trShortened = '1';
        });
      });
    };
    shorten();
    new MutationObserver(shorten).observe(root, { childList: true, subtree: true, characterData: true });
  }

  renderTotals();
})();
